module.exports = __webpack_public_path__ + "static/materials-b3f486c945dcb9672a430bb95cbdd2bf.pdf";